export const REGENERATE_PRESIGNED_URL = gql`
    mutation RegeneratePresignedUrl($url: String!) {
        regenerateSecureAWSUrl(url: $url)
    }
`;
